import React from 'react'
import { Button } from 'components/ui'
import useLocaleText from 'components/useLocaleText'
import { OFFSET_HALFWAY, OFFSET_WHEN_DONE } from '../../model/submission'
import styles from './styles.module.css'

interface IBriefingScheduleProps {
  offsetMinutes: number
  maxOffsetMinutes: number | null
  onOffsetChange: (offsetMinutes: number) => void
}

export function BriefingSchedule({ offsetMinutes, maxOffsetMinutes, onOffsetChange }: IBriefingScheduleProps) {
  const t = useLocaleText({
    minutes: { key: 't_minutes', fallback: { en: 'minutes' } },
    hours: { key: 't_hours', fallback: { en: 'hours' } },
    halfway: { key: 't_halfway', fallback: { en: 'Halfway' } },
    whenDone: { key: 't_when_done', fallback: { en: 'When done' } },
  })
  const presets = [
    { label: `2 ${t.minutes}`, minutes: 2 },
    { label: `15 ${t.minutes}`, minutes: 15 },
    { label: `1 ${t.hours}`, minutes: 60 },
    { label: t.halfway, minutes: OFFSET_HALFWAY },
    { label: t.whenDone, minutes: OFFSET_WHEN_DONE },
  ]

  return (
    <div className={styles.presets}>
      {presets.map((preset) => (
        <Button
          key={preset.minutes}
          type="button"
          variant="filter"
          activeColor="#0F172A"
          borderRadius="20px"
          isActive={offsetMinutes === preset.minutes}
          aria-pressed={offsetMinutes === preset.minutes}
          isDisabled={preset.minutes > 0 && maxOffsetMinutes != null && preset.minutes > maxOffsetMinutes}
          onClick={() => onOffsetChange(preset.minutes)}
        >
          {preset.label}
        </Button>
      ))}
    </div>
  )
}
